import { toOptions } from './ArrayUtil';

export const schoolTypeData = ['聴覚支援学校', '地域公立学校(一般校)', '地域私立学校(一般校)'];
export const schoolTypeOptions = toOptions(schoolTypeData);
